import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { taskActionsProcessComponent } from './task.actions.process.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { DynamicDialogModule } from 'primeng-lts/dynamicdialog';
import { DirectivesModule } from '../directives/directives.module';
import { WaitLoadingModule } from '../components/common/waitLoading/waitLoading.module';
import { A11yModule } from '@angular/cdk/a11y';
import { SubHeaderModule } from '../components/common/sub-header/sub-header.module';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
// import { HelpModule } from '../components/common/help/help.module';


@NgModule({
  declarations: [taskActionsProcessComponent],
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    DynamicDialogModule,
    DirectivesModule,
    WaitLoadingModule,
    A11yModule,
    SubHeaderModule,
    ScrollPanelModule
    // HelpModule
  ]

  // IMPORTANT:
  // Since 'AdditionCalculateWindow' is never explicitly used (in a template)
  // we must tell angular about it.
  // entryComponents: [ AdditionCalculateWindow ]
})
export class TaskActionsProcessModule { }
